import React, { useState, useEffect, useMemo } from "react";
import { Typography, Grid } from "@mui/material";
import CustomTable from "components/TableExplanded/Table";
import CustomPagination from "components/TableExplanded/Pagination";
import useProductData from "pages/SuperAdmin/Customer/data/data";
import useColumns from "pages/SuperAdmin/Customer/columns/mainColumns";
import useColumnsTwo from "pages/SuperAdmin/Customer/columns/SubColumns";
import Modal from "components/Modal/Pawn/BuyProduct/ModalCreate";
import ViewModal from "components/Modal/SuperAdmin/view/viewCustomerList";
import SearchBar from "components/TableExplanded/SearchBar";
import api from "_api";

const CustomerList = ({ className }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [viewProduct, setViewProduct] = useState(null);
  const [fetchData, setFetchData] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const [dataLength, setDataLength] = useState(0);

  const fetchCustomerData = async ({search="",searchCompany="",page = 1, limit = 10 }) => {
    try {
      const { data, isStatus,total } = await api.super_admin.getAllCustomers({search,searchCompany,page , limit});
      if (isStatus) {
        setFetchData(data);
        setDataLength(total);
      }
    } catch (error) {
      console.log("Error fetching product data:", error);
    }
  };

  useEffect(() => {
    fetchCustomerData({ searchCompany: searchQuery, page: page + 1, limit: rowsPerPage });
  }, [searchQuery, page, rowsPerPage]);

  const handleViewOpen = () => {
    setViewModalOpen(!isViewModalOpen);
    if (viewProduct && isViewModalOpen) setViewProduct(null);
  };

  const data = useProductData(fetchData);
  const columns = useColumns(setViewProduct, handleViewOpen);
  const columnsInside = useColumnsTwo();

  const visibleColumns = columns.filter((col) => col.showInFilter);


  const handleSearchChange = (event) => {
    if (event && event.target && event.target.value !== undefined && event.target.value !== null) {
      const query = event.target.value.toLowerCase();
      setSearchTerm(query);
      setSearchQuery(query); 
    } else {
      console.error("Event target or value is undefined");
    }
    setPage(0); 
  };

  const handleClear = () => {
    setSearchTerm("");
    setPage(0);
    fetchCustomerData({ searchCompany: "", page: 1, limit: rowsPerPage })
    
  };

  const handlePageChange = (event, newPage) => {
    if(searchTerm != null)
      {
        setSearchQuery(searchTerm.order_code)
      }
      setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className={className}>
      <Grid container spacing={2} style={{ marginBottom: "16px" }}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography component="div" style={{ fontSize: "32px" }}>
            รายชื่อลูกค้า
          </Typography>
        </Grid>
      </Grid>

      <SearchBar
        columns={columns}
        searchTerm={setSearchTerm}
        visibleColumns={visibleColumns} // กรองคอลัมน์ที่ต้องการแสดง
        handleSearchChange={handleSearchChange}
        handleClear={handleClear}
        fetchData={fetchData}
        handleSearchClick={(filters) =>{
          fetchCustomerData({ searchCompany: filters.company_name || "", page: 1, limit: rowsPerPage })
        }}
        // searchAll={true}
      />

      <CustomTable
        columns={columns}
        columnsInside={columnsInside}
        searchTerm={searchTerm}
        data={data}
        page={page}
        rowsPerPage={rowsPerPage}
        setDataLength={setDataLength}
      />
      <CustomPagination
        count={dataLength}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <ViewModal
        open={isViewModalOpen}
        onClose={handleViewOpen}
        viewProduct={viewProduct}
      />
    </div>
  );
};

export default CustomerList;
